import React, { Dispatch } from "react";
import { NavTreeState } from "./navContext.types";
import { NavTreeAction } from "./navReducer.types";

export const initialState: NavTreeState = {
  navTree: [],
  navTreeSecondary: [],
  measureInProgress: true,
  activeItem: undefined,
  expandedItems: [],
  activeItemParents: [],
  navItemsWidth: [],
  headerMetaData: {
    breakpoint: null,
    isSmallScreen: null,
  },
};

export const NavContext = React.createContext<{
  state: NavTreeState;
  dispatch: Dispatch<NavTreeAction>;
}>({ state: initialState, dispatch: () => null });
